import ProfessionalAccountRegisterForm from 'views/components/organisms/ProfessionalAccountRegisterForm'

const ProfessionalAccountRegisterFormContainer = () => (
  <ProfessionalAccountRegisterForm />
)

export default ProfessionalAccountRegisterFormContainer
